/* =================== VOLTAR AO TOPO =================== */
$(function () {
  function toggleGoTop() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 100) {
      $(".gotop").addClass("active");
    } else {
      $(".gotop").removeClass("active");
    }
  }
  toggleGoTop();
  $(window).on(
    "scroll",
    debounce(function () {
      toggleGoTop();
    }, 100)
  );
  $(".gotop").on("click", function () {
    scrollToX("html");
  });
});

$(function () {
  var t = document.querySelector("#cursor"),
    o = document.querySelector("#cursor-border"),
    n = {
      x: 0,
      y: 0,
    },
    a = {
      x: 0,
      y: 0,
    };
  document.addEventListener("mousemove", function (e) {
    (n.x = e.clientX),
      (n.y = e.clientY),
      (t.style.transform = "translate("
        .concat(e.clientX, "px, ")
        .concat(e.clientY, "px)"));
  }),
    requestAnimationFrame(function e() {
      (a.x += (n.x - a.x) / 8),
        (a.y += (n.y - a.y) / 8),
        (o.style.transform = "translate("
          .concat(a.x, "px, ")
          .concat(a.y, "px)")),
        requestAnimationFrame(e);
    });
});
